import { render } from "./setting.vue?vue&type=template&id=0623bfa6&scoped=true&ts=true"
import script from "./setting.vue?vue&type=script&lang=ts"
export * from "./setting.vue?vue&type=script&lang=ts"

import "./setting.vue?vue&type=style&index=0&id=0623bfa6&lang=less&scoped=true"

import exportComponent from "E:\\lcz\\WX.Unify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0623bfa6"]])

export default __exports__